import type { CSSProperties } from 'react';

interface AvatarProps {
  initials: string;
  color: string;
  size?: number;
  style?: CSSProperties;
}

export function Avatar({ initials, color, size = 32, style }: AvatarProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: size * 0.38,
        fontWeight: 700,
        flexShrink: 0,
        letterSpacing: '-0.5px',
        ...style,
      }}
    >
      {initials}
    </div>
  );
}
